import {Box} from '@mui/material';
import React, {Fragment} from 'react';

import {MainFooter} from 'presentation/components';
import {LayoutContainerProps} from './types';

export function ExamResultsLayoutContainer({children}: LayoutContainerProps) {
	return (
		<Fragment>
			{children}

			<Box mt="auto">
				<MainFooter />
			</Box>
		</Fragment>
	);
}
